var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFullScreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "full-screen-interface-symbol-of-four-arrows-in-square-button",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.273,
    height: 40.273,
    viewBox: "0 0 40.273 40.273",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x32__4_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2186",
    "data-name": "Group 2186"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3297",
    "data-name": "Path 3297",
    d: "M16.054,22.386,10.041,28.4l.028-3.228a1.259,1.259,0,0,0-2.517,0v6.293a1.126,1.126,0,0,0,.4.881,1.25,1.25,0,0,0,.9.378H15.1a1.259,1.259,0,1,0,0-2.517H11.794l6.04-6.04ZM15.1,10.068a1.259,1.259,0,0,0,0-2.517H8.845a1.255,1.255,0,0,0-.9.378,1.126,1.126,0,0,0-.4.881V15.1a1.259,1.259,0,1,0,2.517,0l-.028-3.229,6.013,6.013,1.78-1.78L11.8,10.068ZM31.464,23.912a1.259,1.259,0,0,0-1.259,1.259l.028,3.229-6.013-6.013-1.78,1.78,6.04,6.039H25.171a1.259,1.259,0,1,0,0,2.517h6.258a1.249,1.249,0,0,0,.9-.379,1.121,1.121,0,0,0,.4-.88V25.171A1.259,1.259,0,0,0,31.464,23.912ZM31.428,7.551H25.171a1.259,1.259,0,0,0,0,2.517h3.307l-6.04,6.04,1.78,1.78,6.013-6.013L30.205,15.1a1.259,1.259,0,1,0,2.517,0V8.81a1.13,1.13,0,0,0-.4-.881A1.255,1.255,0,0,0,31.428,7.551ZM35.239,0H5.034A5.034,5.034,0,0,0,0,5.034V35.239a5.034,5.034,0,0,0,5.034,5.034H35.239a5.034,5.034,0,0,0,5.034-5.034V5.034A5.034,5.034,0,0,0,35.239,0Zm2.517,35.239a2.516,2.516,0,0,1-2.517,2.517H5.034a2.516,2.516,0,0,1-2.517-2.517V5.034A2.517,2.517,0,0,1,5.034,2.517H35.239a2.517,2.517,0,0,1,2.517,2.517Z",
    fill: "#ddd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFullScreen);
export default __webpack_public_path__ + "static/media/icon_fullScreen.3ee97c47.svg";
export { ForwardRef as ReactComponent };